import Form from 'Scripts/common/form';

export default class AppPinForm {
    constructor() {
        this.form = new Form({
            form: $('.js-app-pin-form'),
            callback: (data) => {
                window.location.reload();
            }
        });
    } 
}

